import { AsyncOperationsModel } from "../../../../../utility/AsyncOperationsModel";
import { action, observable } from "mobx";
import { IResult } from "../../../../../model/ModelTypes";
import { IUsersOperations } from "../../../../../utility/admin/UsersControls/UsersOperations/IUsersOperations";
import { Observable } from "rxjs";
import { observer } from "mobx-react";
import BaseComponent from "../../../../../utility/BaseComponent";
import * as React from "react";
import { Card, CardText, DialogContainer, Button } from "react-md";
export class VerifyDeleteResultDialogModel extends AsyncOperationsModel {

    @observable selectedResults: IResult[] = [];
    @observable showDialog: boolean = false;
    private readonly userOperations: IUsersOperations;
    private readonly onComplete: Function;

    @action.bound
    setDialogVisibility(flag: boolean) {
        this.showDialog = flag;
    }

    @action.bound
    setSelectedResults(results: IResult[]) {
        this.selectedResults = results;
    }
    @action.bound
    prepare() {
        this.asyncOperationsCount = 0;
    }

    @action.bound
    onCancel() {
        this.resetAsyncOperations();
        this.onComplete(undefined);
    }
    @action.bound
    resetAsyncOperations() {
        this.asyncOperationsCount = 0;
    }
    @action.bound
    onConfirm() {
        this.incrementAsyncOperations();
        Observable.forkJoin(
            this.selectedResults.map( result => this.userOperations.deleteUserResults(result.userId, [result]))
        ).subscribe(
            deletedResultsList => {
                this.resetAsyncOperations();
                let deletedResults = deletedResultsList.reduce( (a, b) => a.concat(b));
                this.onComplete(deletedResults);
            },
            error => {
                this.resetAsyncOperations();
                this.setErrorMessages(["Failed to delete results"]);
            }
        );
    }
    constructor(operations: IUsersOperations, onComplete: Function) {
        super();
        this.userOperations = operations;
        this.onComplete = onComplete;
    }
}

@observer
class VerifyDeleteResultDialog extends BaseComponent<
  { model: VerifyDeleteResultDialogModel },
  {}
> {
  render() {
    return (
      <DialogContainer
        id="delete-results-dialog"
        visible={this.props.model.showDialog}
        onHide={this.props.model.onCancel}
        actions={[
          <Button
            key="cancel"
            flat={true}
            secondary={true}
            onClick={this.props.model.onCancel}
          >
            Cancel
          </Button>,
          <Button
            key="save"
            flat={true}
            secondary={true}
            onClick={this.props.model.onConfirm}
          >
            Confirm
          </Button>
        ]}
        title="Confirm Result Deletion"
      >
        {this.props.model.asyncOperationsCount === 0 &&
          this.props.model.errorMessages.length > 0 && (
            <Card className="messagesCard">
              <CardText className="messageText">
                {this.props.model.errorMessages.map((item, index) => {
                  return <p key={index}>{item}</p>;
                })}
              </CardText>
            </Card>
          )}
        <p>
          Are you sure you want to delete {this.props.model.selectedResults.length} result{this.props.model
            .selectedResults.length > 1
            ? "s"
            : ""}?
        </p>
      </DialogContainer>
    );
  }
}
export default VerifyDeleteResultDialog;


// WEBPACK FOOTER //
// ./src/view/Admin/ResultsView/ResultsTableView/VerifyDeleteResultsDialog/VerifyDeleteResultsDialog.tsx